
import React, { useContext, useEffect, useRef, useState } from 'react';
import { CartContext } from '../contexts/CartContext';
import './cart.css';
import { Link } from 'react-router-dom';
import toast from 'react-hot-toast';
import Photo from '../components/Photo';
import DialogBuy from '../components/dialogbuy';
import axios from 'axios';

const Cart = () => {
  const { cart, removeFromCart, updateQuantity } = useContext(CartContext);

  const [totalPrice, setTotalPrice] = useState(0);
  const [uniqueItems, setUniqueItems] = useState(0);

  const [info, setInfo] = useState({ minPrice: 900 });
  const [isDialogOpen, setIsDialogOpen] = useState(false);

  const prevTotalPriceRef = useRef(0);
  const prevUniqueItemsRef = useRef(0);
  const [animatePrice, setAnimatePrice] = useState(false);
  const [animateItems, setAnimateItems] = useState(false);
  const [isAnimatingPrice, setIsAnimatingPrice] = useState(false);
  const [isAnimatingItems, setIsAnimatingItems] = useState(false);

  
  const [apiUrl, setApiUrl] = useState('');

  
  useEffect(() => {
    fetch('/templates/api.txt')
      .then((res) => res.text())
      .then((data) => {
        setApiUrl(data.trim());
      })
      .catch((err) => console.error('Ошибка при загрузке API URL:', err));
  }, []);

  
  useEffect(() => {
    if (!apiUrl) return;
    fetchInfo();
  }, [apiUrl]);

  const fetchInfo = async () => {
    try {
      const response = await axios.get(`${apiUrl}api/info`);
      setInfo(response.data);
    } catch (error) {
      console.error('Ошибка при запросе /api/info:', error);
    }
  };

  
  useEffect(() => {
    const newTotalPrice = cart.reduce((acc, item) => acc + item.price * item.quantity, 0);
    const newUniqueItems = cart.length;

    
    if (newTotalPrice !== totalPrice && !isAnimatingPrice) {
      setAnimatePrice(true);
      setIsAnimatingPrice(true);
    }

    
    if (newUniqueItems !== uniqueItems && !isAnimatingItems) {
      setAnimateItems(true);
      setIsAnimatingItems(true);
    }

    setTotalPrice(newTotalPrice);
    setUniqueItems(newUniqueItems);

    prevTotalPriceRef.current = newTotalPrice;
    prevUniqueItemsRef.current = newUniqueItems;

    console.log('Cart Page: Текущая корзина:', cart);
  }, [cart, totalPrice, uniqueItems, isAnimatingPrice, isAnimatingItems]);

  const handleCheckout = () => {
    if (totalPrice < info.minPrice) {
      toast.error(`Минимальная сумма заказа ${info.minPrice} ₽`);
      return;
    }
    setIsDialogOpen(true);
  };

  const handlePriceAnimationEnd = () => {
    setAnimatePrice(false);
    setIsAnimatingPrice(false);
  };

  const handleItemsAnimationEnd = () => {
    setAnimateItems(false);
    setIsAnimatingItems(false);
  };

  return (
    <div className="cart-wrapper">
      <h1 className="cart-title">Корзина</h1>
      <div className="cart-content">
        {cart.length === 0 ? (
          <div className="empty-cart">
            <h2>0 Товаров</h2>
            <Link to="/catalog" className="go-to-catalog">
              перейти в каталог
            </Link>
            <div className="empty-cart-line"></div>
          </div>
        ) : (
          <>
            <div className="cart-items-section">
              <ul className="cart-items">
                {cart.map((item) => {
                  
                  
                  
                  
                  const imageSrc = item.image_base64 || item.image || '';

                  return (
                    <li key={item.id} className="cart-item">
                      <div className="cart-item-container">
                        <Photo
                          src={imageSrc}
                          alt={item.title}
                          apiUrl={apiUrl}
                          className="cart-item-image"
                        />
                        <div className="cart-item-details">
                          <h2 className="cart-item-title">{item.title}</h2>
                          <div className="cart-item-controls">
                            <div className="quantity-control">
                              <button
                                onClick={() => {
                                  if (item.quantity > 1) {
                                    updateQuantity(item.id, item.quantity - 1);
                                  }
                                }}
                                className="quantity-button"
                              >
                                -
                              </button>
                              <span className="quantity-number">{item.quantity}</span>
                              <button
                                onClick={() => updateQuantity(item.id, item.quantity + 1)}
                                className="quantity-button"
                              >
                                +
                              </button>
                            </div>
                            <p className="cart-item-price">
                              {item.price.toLocaleString()} ₽
                            </p>
                            <button
                              onClick={() => {
                                console.log(`Cart Page: Удаляем товар. ID: ${item.id}`);
                                removeFromCart(item.id);
                              }}
                              className="remove-button"
                            >
                              &times;
                            </button>
                          </div>
                        </div>
                      </div>
                    </li>
                  );
                })}
              </ul>
            </div>

            <div className="cart-summary-section">
              <div className="cart-summary">
                <h2 className="summary-title">Всего</h2>
                <hr className="summary-line" />
                <div className="summary-items">
                  <span
                    className={`summary-text ${animateItems ? 'animate' : ''}`}
                    onAnimationEnd={handleItemsAnimationEnd}
                  >
                    {uniqueItems} товар
                    {uniqueItems === 1
                      ? ''
                      : uniqueItems > 1 && uniqueItems < 5
                      ? 'а'
                      : 'ов'}
                  </span>
                  <span
                    className={`summary-price ${animatePrice ? 'animate' : ''}`}
                    onAnimationEnd={handlePriceAnimationEnd}
                  >
                    {totalPrice.toLocaleString()} ₽
                  </span>
                </div>
                <p className="minimum-order">
                  Минимальная сумма заказа {info.minPrice} рублей
                </p>
                <div className="promo-code">
                  <input
                    type="text"
                    placeholder="Ввести промокод"
                    className="promo-input"
                  />
                </div>
                <div className="final-summary">
                  <span className="final-text">Итого</span>
                  <span
                    className={`final-price ${animatePrice ? 'animate' : ''}`}
                    onAnimationEnd={handlePriceAnimationEnd}
                  >
                    {totalPrice.toLocaleString()} ₽
                  </span>
                </div>
                <button className="checkout-button" onClick={handleCheckout}>
                  Оформить заказ
                </button>
              </div>
            </div>
          </>
        )}
      </div>

      <DialogBuy
        isOpen={isDialogOpen}
        onClose={() => setIsDialogOpen(false)}
        cartItems={cart}
        totalPrice={totalPrice}
      />
    </div>
  );
};

export default Cart;
